import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FlowManagerService} from '../../../services/flow-manager.service';
import {RolesService} from '../../../../../core/services/roles/roles.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {swalMini} from '../../../../../shared/utils/utils';
import {SharedService} from '../../../../../core/services/store/shared-store/shared-storage.service';
import {Router} from '@angular/router';
import {BotService} from '../../../services/bot.service';

@Component({
  selector: 'app-save-to-existing-bot-modal',
  templateUrl: './save-to-existing-bot-modal.component.html',
  styleUrls: ['./save-to-existing-bot-modal.component.scss']
})

export class SaveToExistingBotModalComponent implements OnInit {

  changesMade: Boolean = false;
  nextForm;
  savingInProgress: Boolean = false;
  botList: string[] = [];
  existingForm: FormGroup;
  listOfExisingBots$: any;
  containsWrongValue: Boolean = false;
  isThisAFolderName = false;
  isTagsTouched = false;
  isEditMode = false;
  botId = '';
  loadingData = true;
  flow: any;
  botMetaData: any;
  private templateName: any;
  private botIdsList: string[];

  constructor(
      public dialog: MatDialog,
      private rolesService: RolesService,
      private botService: BotService,
      public dialogRef: MatDialogRef<SaveToExistingBotModalComponent>,
      private botFromBuilder: FormBuilder,
      private flowManagerService: FlowManagerService,
      public sharedService: SharedService,
      private router: Router
  ) {
    this.buildForm();
    this.nextForm = new FormGroup({
      next: new FormControl('start')
    });

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  buildForm() {
    this.existingForm = this.botFromBuilder.group({
     existingBotList: new FormControl( '', [Validators.required]),
     templateName: new FormControl( '', [Validators.required])
    });
  }

  ngOnInit(): void {
    this.selectNewBot();
    if (this.dialogRef._containerInstance._config.data && this.dialogRef._containerInstance._config.data.isEdit) {
      this.isEditMode = this.dialogRef._containerInstance._config.data.isEdit;
      if (!this.isEditMode) { this.loadingData = false; }
    }
  }

  closeModal() {
    this.dialogRef.close();
  }

  selectNewBot() {
    this.fetchAllBotData();
    if (this.botList) {
      this.listOfExisingBots$ = this.botList;
    }
    return this.listOfExisingBots$;
  }

  fetchAllBotData() {
    this.botService.getBotList().subscribe(
        (data) => {
          this.botMetaData = data.body;
        },
        error => {
          this.loadingData = false;
        },
        () => {
          this.fetchBotList();
          this.loadingData = false;
        }
    );
  }

  fetchBotList() {
    this.botService.getBotList().subscribe(
        (data) => {
          console.log('data', data);
          const fetchedBotList = Object.values(data.body['bots']);
          const fetchedBotId = Object.keys(data.body['bots']);
          const botNames = fetchedBotList.map(element => {
            return element.toString();
          });
          const botIds = fetchedBotId.map(element => {
            return element.toString();
          });
          if (this.isEditMode) {
            this.botList = botNames.filter((element) => {
              return element !== this.botMetaData.name;
            });
          } else {
            this.botList = botNames;
          }
          this.botIdsList = botIds;

        },
        error => {
          swalMini({
            title: 'Problem occurred, try again',
            text: '',
            type: 'warning',
          });
        },
        () => {
        }
    );
  }

  saveExistingModal() {
    const templateData = this.existingForm.getRawValue();
    const botId = this.botIdsList[this.listOfExisingBots$.indexOf(this.existingForm.controls['existingBotList'].value)];
    this.flow = this.dialogRef._containerInstance._config.data.flow;
    const stageTemplateRequest = {
      flowName: templateData.templateName,
      flowPath: botId + '/' + templateData.templateName,
      flow: this.flow,
      message: ''
    }
    this.botService.saveTemplate(stageTemplateRequest).subscribe(
        (templateData) => {
          if(templateData.status === 200) {
            swalMini({
              title: 'Saved successfully!',
              text: '',
              type: 'success',
            });
            this.savingInProgress = false;
            this.dialogRef.close();
            this.successfullCreateOrUpdate(templateData.body);

          } else {
            this.savingInProgress = false;
            swalMini({
              title: 'Problem occurred while saving',
              text: '',
              type: 'warning',
            });
          }
        },
        error => {
          this.savingInProgress = false;
          swalMini({
            title: 'Problem occurred while saving',
            text: '',
            type: 'warning',
          });
        },
        () => {}
    );
}

  saveTemplateNameChange(value: any) {
   this.testChanges();
   this.containsWrongValue = !!(value.includes('/') || value.includes('\\'));
  }

  testChanges() {
    const currentInput = this.existingForm.controls['templateName'];
    const currentDropdown = this.existingForm.controls['existingBotList'];
    this.changesMade = !((currentInput.dirty || currentInput.dirty || currentInput.invalid) &&
        (currentDropdown.touched || currentDropdown.dirty || currentDropdown.dirty));
    this.changesMade = !(!currentInput.value || currentDropdown.value.length === 0 && !currentDropdown.value || currentDropdown.value.length === 0 && currentInput.value.includes('/') || currentInput.value.includes('\\'));
  }

  private successfullCreateOrUpdate(isSuccess) {
    this.flowManagerService.clearFlowNameCache();
    const path = isSuccess.flowMetaData
        ? isSuccess.flowMetaData.directory
        : this.sharedService.flow.metaData.directory;

    let flowPath = this.extractFlowPath(path).replace(/\//g, ',');
    const flowId = isSuccess.flowMetaData
        ? isSuccess.flowMetaData.flowId
        : this.sharedService.getFlowRef;
    flowPath = flowPath + flowId;
    // @ts-ignore
    this.saveFlowStatus = false;

    this.sharedService.setNewFlowSaved(true);
    this.router.navigate([
      'flow',
      this.sharedService.getEnvironment(),
      this.sharedService.getEntityType(),
      this.sharedService.getEntityId(),
      flowPath,
    ]);
  }

  extractFlowPath(flowPath: any) {
    const lastIndexOf = flowPath.lastIndexOf('/');
    const path = lastIndexOf !== -1 ? flowPath.slice(0, lastIndexOf) + ',' : '';
    return path;
  }
}